import React from "react";
import "./DigitalMarketing.css";
import {
  FaBullhorn,
  FaSearchDollar,
  FaChartLine,
  FaUsers,
  FaEnvelopeOpenText,
  FaObjectGroup,
  FaRetweet,
  FaPlayCircle,
  FaMobileAlt,
  FaGlobeAmericas,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaIdBadge,
} from "react-icons/fa";
import DigitalMarketingimg from "../../images/digital marketings.jpg";
import { Link } from "react-router-dom";

const coreServices = [
  {
    icon: <FaSearchDollar />,
    title: "Performance Marketing",
    text: "ROI-focused campaigns across Google Ads, Meta, and other ad networks.",
    tag: "Search & Display Ads",
  },
  {
    icon: <FaBullhorn />,
    title: "Brand & Awareness",
    text: "Strategic campaigns that keep your brand top-of-mind for your audience.",
    tag: "Brand Positioning",
  },
  {
    icon: <FaUsers />,
    title: "Social Media Management",
    text: "Content calendars, creatives, and community engagement across channels.",
    tag: "Organic Growth",
  },
  {
    icon: <FaEnvelopeOpenText />,
    title: "Email & Automation",
    text: "Lifecycle journeys that nurture leads, retain customers, and boost LTV.",
    tag: "Retention Flows",
  },
  {
    icon: <FaChartLine />,
    title: "Analytics & CRO",
    text: "Track every click, test every idea, and optimize funnels for conversions.",
    tag: "Data-Driven Decisions",
  },
  {
    icon: <FaObjectGroup />,
    title: "Creatives & Landing Pages",
    text: "High-converting landing pages, banners, and video storyboards.",
    tag: "Design + Copy",
  },
];

const strategies = [
  {
    number: "1",
    title: "Branding",
    text: "End-to-end brand identity — logo, messaging, visual language, and digital presence that your customers remember.",
    icon: <FaIdBadge />,
  },
  {
    number: "2",
    title: "Lead Generation",
    text: "High-intent leads from search, social, and landing pages built to capture and qualify your ideal customers.",
    icon: <FaSearchDollar />,
  },
  {
    number: "3",
    title: "Video Marketing",
    text: "Product demos, explainers, and short-form content that tell your story in seconds across YouTube and social.",
    icon: <FaPlayCircle />,
  },
  {
    number: "4",
    title: "App & Web Promotion",
    text: "Acquisition and re-engagement campaigns that drive installs, signups, and repeat usage for apps and websites.",
    icon: <FaMobileAlt />,
  },
  {
    number: "5",
    title: "Web Traffic",
    text: "SEO, paid traffic, and remarketing strategies aligned to your business goals and revenue targets.",
    icon: <FaRetweet />,
  },
  {
    number: "6",
    title: "Analytics",
    text: "Data-driven insights, performance dashboards, and A/B testing that continuously improve your marketing ROI.",
    icon: <FaChartLine />,
  },
];

const channels = [
  {
    icon: <FaGlobeAmericas />,
    title: "SEO & Organic Search",
    text: "Technical SEO, on-page optimization, and content strategy for long-term visibility.",
  },
  {
    icon: <FaMobileAlt />,
    title: "App Marketing",
    text: "Acquire and retain app users with install campaigns and in-app engagement.",
  },
  {
    icon: <FaInstagram />,
    title: "Instagram & Reels",
    text: "Short-form content, influencer collaborations, and performance-driven creatives.",
  },
  {
    icon: <FaFacebookF />,
    title: "Meta Suite",
    text: "Facebook + Instagram ads optimized for reach, traffic, and sales.",
  },
  {
    icon: <FaLinkedinIn />,
    title: "LinkedIn B2B",
    text: "Account-based campaigns for decision makers in your ideal industries.",
  },
  {
    icon: <FaPlayCircle />,
    title: "YouTube & Video",
    text: "Awareness and consideration campaigns through powerful video storytelling.",
  },
];

const processSteps = [
  {
    step: "01",
    title: "Discover & Audit",
    text: "We deep-dive into your brand, competition, and existing data to find the fastest growth levers.",
  },
  {
    step: "02",
    title: "Plan & Architect",
    text: "We design campaign structures, audiences, funnels, and tracking so every rupee is accountable.",
  },
  {
    step: "03",
    title: "Launch & Experiment",
    text: "We launch multiple variations, test creatives, audiences, and offers to find winning combinations.",
  },
  {
    step: "04",
    title: "Optimize & Scale",
    text: "We double down on what works, cut waste, and incrementally scale your marketing engine.",
  },
];

const reasons = [
  {
    title: "Full-Funnel Thinking",
    text: "From awareness to retention, we design journeys instead of isolated campaigns.",
  },
  {
    title: "Transparent Reporting",
    text: "Clear dashboards: spend, revenue, ROAS, CAC, and key KPIs you actually care about.",
  },
  {
    title: "Tech + Creative Team",
    text: "Engineers, analysts, and designers under one roof at Aazira Solutions.",
  },
  {
    title: "Industry-Agnostic Playbooks",
    text: "Experience with SaaS, D2C, B2B, services, and more — we adapt quickly.",
  },
];

export default function DigitalMarketing() {
  return (
    <div className="dm-page">
      {/* HERO */}
      {/* <section className="dm-hero">
        <div className="dm-hero-orb dm-hero-orb-left" />
        <div className="dm-hero-orb dm-hero-orb-right" />

        <div className="dm-hero-inner">
          <div className="dm-hero-content">
            <span className="dm-hero-pill">Digital Marketing Services</span>
            <h1 className="dm-hero-title">
              Grow your brand.{" "}
              <span className="dm-hero-highlight">Measure every click.</span>
            </h1>
            <p className="dm-hero-subtitle">
              Aazira Solutions helps you attract the right audience, convert
              them into customers, and keep them coming back — with full-funnel
              digital marketing.
            </p>

            <ul className="dm-hero-points">
              <li>
                ✔ Performance-first strategy across search, social, and email.
              </li>
              <li>
                ✔ Real-time dashboards and weekly action-oriented reports.
              </li>
              <li>
                ✔ A dedicated marketing squad that thinks like your in-house
                team.
              </li>
            </ul>

            <div className="dm-hero-cta-row">
              <Link to="/contact">
              <button className="dm-cta-primary">Get a Marketing Audit</button>
              </Link>
            </div>
          </div>

          <div className="dm-hero-visual">
            <img src={DigitalMarketingimg} alt="Hero Visual" className="dm-hero-img" />
          </div>
        </div>
      </section> */}
      <section className="dm-hero">
  <div className="dm-hero-overlay"></div>

  <div className="dm-hero-orb dm-hero-orb-left" />
  <div className="dm-hero-orb dm-hero-orb-right" />

  <div className="dm-hero-inner">
    <div className="dm-hero-content">
      <span className="dm-hero-pill fade-up">Digital Marketing Services</span>

      <h1 className="dm-hero-title fade-up delay-1">
        Grow your brand.{" "}
        <span className="dm-hero-highlight">Measure every click.</span>
      </h1>

      <p className="dm-hero-subtitle fade-up delay-2">
        Aazira Solutions helps you attract the right audience, convert them
        into customers, and keep them coming back — with full-funnel digital
        marketing.
      </p>

      <ul className="dm-hero-points fade-up delay-3">
        <li>✔ Performance-first strategy across search, social, and email.</li>
        <li>✔ Real-time dashboards and weekly action-oriented reports.</li>
        <li>✔ A dedicated marketing squad that thinks like your in-house team.</li>
      </ul>

      <div className="dm-hero-cta-row fade-up delay-4">
        <Link to="/contact">
          <button className="dm-cta-primary">Get a Marketing Audit</button>
        </Link>
      </div>
    </div>

    {/* <div className="dm-hero-visual fade-up delay-5">
      <img
        src={DigitalMarketingimg}
        alt="Digital Marketing Visual"
        className="dm-hero-img"
      />
    </div> */}
  </div>
</section>


      {/* CORE SERVICES */}
      <section className="dm-section dm-core-services">
        <div className="dm-section-header">
          <h2>Our Digital Marketing Services</h2>
          <p>
            A connected set of services to help you plan, launch, and scale
            campaigns that actually move business metrics.
          </p>
        </div>

        <div className="dm-services-grid">
          {coreServices.map((s, idx) => (
            <article className="dm-service-card" key={idx}>
              <div className="dm-service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
              <span className="dm-service-tag">{s.tag}</span>
            </article>
          ))}
        </div>
      </section>

      {/* NEW: TAILORED STRATEGIES SECTION */}
      <section className="dm-section dm-strategies">
        <div className="dm-section-header">
          <h2>Tailored Strategies to Boost Your Business</h2>
          <p>
            Every brand needs a different growth path. We combine these pillars
            to design a digital strategy that fits your goals and budget.
          </p>
        </div>

        <div className="dm-strategies-grid">
          {strategies.map((st, idx) => (
            <div className="dm-strategy-card" key={idx}>
              <span className="dm-strategy-number">{st.number}</span>
              <div className="dm-strategy-icon">{st.icon}</div>
              <h3>{st.title}</h3>
              <p>{st.text}</p>
              <div className="dm-strategy-sheen" />
            </div>
          ))}
        </div>
      </section>

      {/* CHANNELS */}
      <section className="dm-section dm-channels">
        <div className="dm-section-header">
          <h2>Channels We Activate</h2>
          <p>
            Meet your customers where they already spend time — with messaging,
            creatives, and offers tailored to each platform.
          </p>
        </div>

        <div className="dm-channels-grid">
          {channels.map((c, idx) => (
            <div className="dm-channel-card" key={idx}>
              <div className="dm-channel-icon">{c.icon}</div>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="dm-section dm-process">
        <div className="dm-section-header">
          <h2>How We Work With You</h2>
          <p>
            A simple, predictable process — so you always know what we are doing
            and why.
          </p>
        </div>

        <div className="dm-process-grid">
          {processSteps.map((p, idx) => (
            <div className="dm-process-card" key={idx}>
              <div className="dm-process-step">
                <span>{p.step}</span>
              </div>
              <h3>{p.title}</h3>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* WHY CORDON */}
      <section className="dm-section dm-why">
        <div className="dm-section-header">
          <h2>Why Choose Aazira Solutions</h2>
          <p>
            We blend engineering discipline with marketing creativity to build a
            growth engine — not just isolated campaigns.
          </p>
        </div>

        <div className="dm-why-grid">
          {reasons.map((r, idx) => (
            <div className="dm-why-card" key={idx}>
              <h3>{r.title}</h3>
              <p>{r.text}</p>
            </div>
          ))}
        </div>

        <div className="dm-section-cta">
          <h3>Let&apos;s plan your next growth sprint.</h3>
          <p>
            Share your goals, channels you&apos;re using, and current
            challenges. We&apos;ll come back with a short, actionable roadmap.
          </p>
          <Link to="/contact">
          <button className="dm-cta-primary dm-cta-primary-large">
            Book a 30-Minute Strategy Call
          </button>
          </Link>
        </div>
      </section>
    </div>
  );
}
